<template>
<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M6.5 2C4.025 2 2 4.025 2 6.5C2 8.975 4.025 11 6.5 11C8.975 11 11 8.975 11 6.5C11 4.025 8.975 2 6.5 2ZM6.5 2.9C6.995 2.9 7.355 3.305 7.31 3.8L6.95 7.4H6.05L5.69 3.8C5.645 3.305 6.005 2.9 6.5 2.9ZM6.5 10.1C6.005 10.1 5.6 9.695 5.6 9.2C5.6 8.705 6.005 8.3 6.5 8.3C6.995 8.3 7.4 8.705 7.4 9.2C7.4 9.695 6.995 10.1 6.5 10.1Z"
      fill="#DD1515"/>
</svg>
</template>
